import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { AccountReactivateOutlineIcon } from '@weblite/icons'
import { styled, Typography } from '@mui/material'
import { BottomDrawer } from '$common/bottom-drawer'
import { PrimaryButton } from '$common/buttons'
import { toLocale } from '$func/text'
import { t } from '$i18n'

const steps = [
  t('syncIOSAccounts.howToEnableSyncDialog.steps.first'),
  t('syncIOSAccounts.howToEnableSyncDialog.steps.second'),
  t('syncIOSAccounts.howToEnableSyncDialog.steps.third'),
  t('syncIOSAccounts.howToEnableSyncDialog.steps.fourth'),
  t('syncIOSAccounts.howToEnableSyncDialog.steps.fifth'),
  t('syncIOSAccounts.howToEnableSyncDialog.steps.sixth'),
] as string[]

export function HowToSyncIosContactsModal({
  isOpen = false,
}: {
  isOpen?: boolean
}) {
  const handleConfirm = async () => {
    await closeCurrentModal()
  }

  return (
    <BottomDrawer isOpen={isOpen} onClose={closeCurrentModal}>
      <Root>
        <HeaderImage>
          <AccountReactivateOutlineIcon
            sx={{ width: '56px', height: '56px', color: 'secondary700' }}
          />
        </HeaderImage>
        <Typography variant="subtitle1">
          {t('syncIOSAccounts.howToEnableSyncDialog.title')}
        </Typography>
        <StepsWrapper>
          {steps.map((step, index) => (
            <Typography variant="paragraph1" key={step}>
              {`${toLocale(index + 1, false)}- ${step}`}
            </Typography>
          ))}
        </StepsWrapper>
        <PrimaryButton
          sx={{ mt: '16px' }}
          text={
            <Typography color="inherit" variant="subtitle1">
              {t('syncIOSAccounts.howToEnableSyncDialog.confirm')}
            </Typography>
          }
          onClick={handleConfirm}
        />
      </Root>
    </BottomDrawer>
  )
}

const Root = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`

const HeaderImage = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 140px;
  background-color: ${({ theme }) => theme.palette.secondary50};
`

const StepsWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 4px;
`
